import { SystemAdminNotification } from "src/globalTypes";

export const getAdminNotifications = (
  notifications: SystemAdminNotification[]
) => {
  const notifTemplateNotification = notifications.find(
    ({ type }) => type === "notificationTemplate"
  );
  const defaultMappingNotification = notifications.find(
    ({ type }) => type === "defaultMapping"
  );

  return {
    notifTemplateNotification,
    defaultMappingNotification,
  };
};
